var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CloseFilled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.6663 4.27333L11.7263 3.33333L7.99967 7.06L4.27301 3.33333L3.33301 4.27333L7.05967 8L3.33301 11.7267L4.27301 12.6667L7.99967 8.94L11.7263 12.6667L12.6663 11.7267L8.93967 8L12.6663 4.27333Z",
    fill: "#1D1D1B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseFilled);
export default __webpack_public_path__ + "static/media/CloseFilled.ba7d0773fc084aeae26ade1dfc4c4314.svg";
export { ForwardRef as ReactComponent };